export default __webpack_public_path__ + "669694706dbf9e8274e4e64fc5300341.png";